import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledValueInput } from './styles';
import { getDataQAForInput } from '__components/Inputs/helpers';

type ValueInputProps = {
  value: string;
  onChange: (value: string) => string;
  error?: string[];
  validate?: any;
};

export const ValueInput: FC<ValueInputProps> = ({
  value,
  onChange,
  error,
  validate,
}) => {
  const { t } = useTranslation();

  const [innerValue, setInnerValue] = useState<string>(value);

  const handleChange = (value: string) => {
    setInnerValue(value);
  };

  const handleBlur = () => {
    const changed = onChange(innerValue);
    setInnerValue(changed);
  };

  useEffect(() => {
    setInnerValue(value);
  }, [value]);

  return (
    <StyledValueInput
      value={innerValue}
      label={t('Value')}
      placeholder={t('Enter Value')}
      onChange={handleChange}
      onBlur={handleBlur}
      error={error}
      validate={validate}
      {...getDataQAForInput('variable-value', 'text')}
    />
  );
};
